import { render } from "./CaseDetail-page.vue?vue&type=template&id=7251f272&scoped=true"
import script from "./CaseDetail-page.vue?vue&type=script&lang=js"
export * from "./CaseDetail-page.vue?vue&type=script&lang=js"

import "./CaseDetail-page.vue?vue&type=style&index=0&id=7251f272&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7251f272"]])

export default __exports__